import _ from 'underscore';
import { mapState } from 'vuex';
import f from '@/application/shared/functions.js'

export default {
	name: 'code_preview',
	props: {
		code : Object
	},

	components : {
		
	},

	data : function(){

		return {}

	},

	created() {
		

	},

	destroyed() {
	},

	watch: {
		
	},
	computed: mapState({
		
		auth : state => state.auth,
		
	}),

	methods : {

		copycode : function(){
			f.copytext(this.code.code)

			this.core.sitemessage(this.$t('labels.copied'))
		}
		
	},
}